import React from 'react';
import {useTranslation} from 'react-i18next';


const SUGGESTED_PROMPTS = [
    'agent_chat.prompt_how_campaigns',
    'agent_chat.prompt_spend_by_channel',
    'agent_chat.prompt_worst_campaigns',
    'agent_chat.prompt_weekly_report',
];

export const AgentEmptyState = ({onPromptClick}) => {
    const {t} = useTranslation();

    return (
        <div className="agent-empty-state">
            <div className="agent-empty-state__avatar">
                <i className="fas fa-robot"></i>
            </div>
            <h3 className="agent-empty-state__greeting">
                {t('agent_chat.empty_greeting')}
            </h3>
            <p className="agent-empty-state__subtitle">
                {t('agent_chat.empty_subtitle')}
            </p>
            <div className="agent-empty-state__prompts">
                {SUGGESTED_PROMPTS.map((key) => (
                    <button
                        key={key}
                        className="agent-empty-state__prompt-chip"
                        onClick={() => onPromptClick(t(key))}
                    >
                        {t(key)}
                    </button>
                ))}
            </div>
        </div>
    );
};
